const hasFullLiveAccess = () => localStorage.getItem("full_live_access_token") === process.env.REACT_APP_FULL_LIVE_ACCESS_TOKEN

export default hasFullLiveAccess